var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { FormProvider, useForm } from "react-hook-form";
import FooterContactUsForm from "template/footer/contact/FooterContactUsForm";
import { yupResolver } from '@hookform/resolvers/yup';
import { lazy, object, string } from "yup";
import { numberYupRegex } from "tools/tools";
import useLang from "hook/useLang";
import AxiosService from "tools/AxiosService";
import { API } from "tools/CONST";
import CustomSweetAlert from "component/alertCustomSweetAlert/CustomSweetAlert";
import DonutSpinner from "component/donutSpinner/DonutSpinner";
import classNames from "classnames";
var initialAlert = {
    show: false,
    title: '',
    success: false,
    danger: false,
};
function FooterContactUs() {
    var _this = this;
    var lang = useLang();
    var _a = useState(initialAlert), alert = _a[0], setAlert = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var errors = lang.file.footer.contactUs.errors;
    var schema = object().shape({
        name: lazy(function (value) {
            if (value) {
                return string().typeError(errors.name.typeError).min(5, errors.name.min);
            }
            else {
                return string().typeError(errors.name.typeError);
            }
        }),
        phoneNumber: lazy(function (value) {
            if (value) {
                return string().matches(numberYupRegex, errors.phoneNumber.matches).min(7, errors.phoneNumber.min);
            }
            else {
                return string();
            }
        }),
        email: string().required(errors.email.required).email(errors.email.email),
        body: string().required(errors.body.required).min(50, errors.body.min),
        category: object(),
    });
    var methods = useForm({
        defaultValues: {
            name: '',
            phoneNumber: '',
            email: '',
            body: '',
            category: {},
        },
        mode: 'all',
        resolver: yupResolver(schema),
    });
    var handleSubmit = methods.handleSubmit, reset = methods.reset;
    var onSubmit = function (payload, event) { return __awaiter(_this, void 0, void 0, function () {
        var body, sendData, res, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    console.log('event', event);
                    console.log('payload', payload);
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    body = {
                        body: payload.body,
                        email: payload.email,
                    };
                    if (payload.name) {
                        body.name = payload.name;
                    }
                    if ((_a = payload === null || payload === void 0 ? void 0 : payload.category) === null || _a === void 0 ? void 0 : _a.id) {
                        body.question_type = payload.category.id;
                    }
                    if (payload.phoneNumber) {
                        body.phone_number = payload.phoneNumber;
                    }
                    sendData = new AxiosService({ url: API.BASE + API.QUESTION, method: 'post', body: body });
                    return [4, sendData.api()];
                case 2:
                    res = _b.sent();
                    console.log('res', res);
                    reset();
                    setAlert({
                        show: true,
                        title: 'درخواست شما با موفقیت ثبت شد',
                        success: true,
                        danger: false,
                    });
                    setLoading(false);
                    return [3, 4];
                case 3:
                    e_1 = _b.sent();
                    console.log('sendData error', e_1);
                    setAlert({
                        show: true,
                        title: 'مشکلی پیش آمده است دوباره تلاش کنید',
                        success: false,
                        danger: true,
                    });
                    setLoading(false);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var onClose = function () { return setAlert(initialAlert); };
    var showAlert = function () {
        if (alert.show) {
            return (React.createElement(CustomSweetAlert, { title: alert.title, danger: alert.danger, success: alert.success, onConfirm: onClose, onCancel: onClose }));
        }
        return null;
    };
    var btn = classNames({
        'text-15 font-medium border border-black border-opacity-25 rounded-md px-10 py-1 focus:outline-none disabled:opacity-50': true,
        'hover:border-opacity-100': !loading
    });
    return (React.createElement(FormProvider, __assign({}, methods),
        showAlert(),
        React.createElement("form", { id: 'contactus', autoComplete: 'off', onSubmit: handleSubmit(onSubmit) },
            React.createElement(FooterContactUsForm, null),
            React.createElement("div", { className: 'flex items-center justify-end' },
                React.createElement("div", { className: 'relative' },
                    React.createElement("button", { type: 'submit', disabled: loading, className: btn }, lang.file.footer.contactUs.button),
                    loading ?
                        React.createElement("div", { className: 'footerDonutDiv' },
                            React.createElement(DonutSpinner, { className: 'footerDonut' }))
                        : null)))));
}
export default FooterContactUs;
